// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-left.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-left',
  version: 'outline',
  paths: [
    {
      d: 'M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18',
    },
  ],
}
